import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface SkeletonAgendaProps {
  count: number;
}

function SkeletonAgenda({ count }: SkeletonAgendaProps) {
  const renderSkeletons = () => {
    const skeletons = [];
    for (let i = 0; i < count; i++) {
      skeletons.push(
        <div className=" flex flex-col">
          <div className="  mb-9 flex flex-row gap-4">
            <div className="SkeletonTimeDurationColumn flex w-1/4 flex-col">
              <Skeleton />
              <Skeleton />
            </div>
            <div className="SkeletonEventCard flex w-full flex-col">
              <Skeleton height={150} />
            </div>
          </div>
        </div>
      );
    }
    return skeletons;
  };
  return (
    <div className="SkeletonAgenda flex w-full flex-col items-start justify-start gap-6">
      <div className="SkeletonDayBlock flex w-full flex-col items-center justify-start gap-4 md:items-start">
        <div className="TimelineContainer w-full flex-col items-start justify-start gap-4 md:items-start">
          {renderSkeletons()}
        </div>
      </div>
    </div>
  );
}

export default SkeletonAgenda;
